import { useRating } from '@risksmart-app/components/src/hooks/useRating';
import SimpleRatingBadge from '@risksmart-app/components/src/simple-rating-badge/SimpleRatingBadge';
import { type AssetTableFields } from 'src/pages/assets/types';

import { EMPTY_CELL } from '@/utils/collectionUtils';

export type AssetStatusBadgeProps = {
  item: Pick<AssetTableFields, 'Status'>;
};

const AssetStatusBadge = ({ item }: AssetStatusBadgeProps) => {
  const status = useRating('asset_status');

  const rating = status.getByValue(item.Status);

  return rating ? <SimpleRatingBadge rating={rating} /> : EMPTY_CELL;
};

export default AssetStatusBadge;
